import React from "react";

// Helper to format ms to "0m 30s"
const formatDuration = (startMs, endMs) => {
  const durationSec = Math.max(0, endMs / 1000);
  const mins = Math.floor(durationSec / 60);
  const secs = Math.floor(durationSec % 60);
  return `${mins}m ${secs.toString().padStart(2, "0")}s`;
};

// Helper to group consecutive messages by channel
const groupMessages = transcripts => {
  if (!transcripts || transcripts.length === 0) return [];

  const groups = [];
  let currentGroup = {
    channel: transcripts[0].channel,
    messages: [transcripts[0]],
  };

  for (let i = 1; i < transcripts.length; i++) {
    const current = transcripts[i];

    // If same channel as previous, add to current group
    if (current.channel === currentGroup.channel) {
      currentGroup.messages.push(current);
    } else {
      // Different channel, start new group
      groups.push(currentGroup);
      currentGroup = {
        channel: current.channel,
        messages: [current],
      };
    }
  }

  // Don't forget the last group
  groups.push(currentGroup);

  return groups;
};

const TranscriptConversation = ({ transcripts = [], direction = "INBOUND" }) => {
  const messageGroups = groupMessages(transcripts);

  return (
    <div className="w-full p-4 bg-white rounded-lg overflow-y-auto" style={{ maxHeight: 600 }}>
      <div className="flex flex-col gap-4">
        {messageGroups.map((group, groupIdx) => {
          const isLeft = group.channel === 0;

          return (
            <div
              key={groupIdx}
              className={`flex ${isLeft ? "justify-start" : "justify-end"} w-full mb-3`}
            >
              <div className={`flex flex-col ${isLeft ? "items-start" : "items-end"}`}>
                {/* Header with speaker and time - outside the card */}
                <div className="flex items-center gap-2 mb-1 px-1">
                  {isLeft ? (
                    <>
                      {direction === "OUTBOUND" && (
                        <span className="text-blue-600 font-medium text-xs">Caller</span>
                      )}
                      <span className="text-gray-500 text-xs font-mono">
                        {formatDuration(
                          group.messages[group.messages.length - 1].startTimeMs,
                          group.messages[group.messages.length - 1].startTimeMs
                        )}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="text-gray-500 text-xs font-mono">
                        {formatDuration(
                          group.messages[group.messages.length - 1].startTimeMs,
                          group.messages[group.messages.length - 1].startTimeMs
                        )}
                      </span>
                      <span className="text-blue-600 font-medium text-xs">Callee</span>
                    </>
                  )}
                </div>

                {/* Message card */}
                <div
                  className={`px-4 py-2 text-sm shadow-sm break-words ${
                    isLeft
                      ? "bg-blue-100 text-gray-900 rounded-2xl rounded-tl-none"
                      : "bg-gray-200 text-gray-900 rounded-2xl rounded-tr-none"
                  }`}
                  style={{ maxWidth: "80%", minWidth: 400 }}
                >
                  {group.messages.map(message => message.transcript.trim()).join(" ")}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TranscriptConversation;
